import { DepoimentosModel } from "./depoimentos.model";
export const depoimentos: DepoimentosModel[] = [
    {
        Empresa: `Banco Santander`,
        // Imagkem: `../../assets/img/depoimentos/santander.png`,
        Cargo: `Ger. Venda de Serviços PJ`,
        Pessoa: `Hendrix Azevedo de Carvalho`,
        Data: `18 de agosto de 2017`,
        Depoimento: `
        Pqp tá muito fod******!  
        Contrata esse MITO pra desenvolver o formulário de todos os produtos.
        [...]
        Bjo.`,
    }, {
        Empresa: `Método Supera`,
        Imagem: `../../assets/img/depoimentos/supera.png`,
        Cargo: `Gestor Comercial`,
        Pessoa: `Carlos `,
        Data: ``,
        Depoimento: `Ficou sensacional! Muito melhor que todos os produtos de mercado!
        Ele atende exatamente a nossa realidade, é muito fácil e personalizado!`,
    }, {
        Empresa: `Santander S3`,
        // Imagem: `../../assets/img/depoimentos/santanderS3.png`,
        Cargo: `Reguladores e Liquidação SAM`,
        Pessoa: `Juliana Visse Munhoz`,
        Data: `11 de março de 2020`,
        Depoimento: `Agradeço sua equipe pela ajuda que deram no projeto[...]
        Com a ajuda de vocês, estamos reduzindo o trabalho manual.
        Parabéns a equipe!`,
    }, {
        Empresa: `Santander S3`,
        // Imagem: `../../assets/img/depoimentos/santanderS3.png`,
        Cargo: `Diretoria de Riscos & Compilance`,
        Pessoa: `Fábio José Miranda`,
        Data: `26 de março de 2020`,
        Depoimento: `Gostaria de agradecer ao apoio dado aos ajustes das nossas ferramentas[...]
        que de forma tempestiva nos auxilia e efetua os ajustes[...] sem ocorrer nenhum impacto negativo[...]`,
    }
]